// extracted by mini-css-extract-plugin
export var center_children = "styles-module--center_children--c9d00";